export default {
    en: {
        title_login: "Login",
        authenticating : "Authenticating...",
        offline_message: "Please check your connection, login feature is not available offline.",
        sign_in_with_google: "Sign in with Google"
    },
    el: {
        title_login: "Σύνδεση",
        authenticating : "Έλεγχος ταυτότητας...",
        offline_message: "Παρακαλώ ελέγξτε την σύνδεση σας, η σύνδεση δεν μπορεί να πραγματοποιηθεί ενώ δεν έχετε" +
            " σύνδεση στο internet.",
        sign_in_with_google: "Σύνδεση με την Google"
    }
};
